import { Input } from "@/components/ui/input";

interface SEOFormInputsProps {
  url: string;
  keyword: string;
  onUrlChange: (value: string) => void;
  onKeywordChange: (value: string) => void;
}

export function SEOFormInputs({ url, keyword, onUrlChange, onKeywordChange }: SEOFormInputsProps) {
  return (
    <>
      <div className="space-y-4">
        <label htmlFor="keyword" className="text-sm font-medium text-gray-700">
          Palavra-chave
        </label>
        <Input
          id="keyword"
          type="text"
          placeholder="Ex: marketing digital"
          value={keyword}
          onChange={(e) => onKeywordChange(e.target.value)}
          className="w-full"
          required
        />
      </div>
      <div className="space-y-4">
        <label htmlFor="url" className="text-sm font-medium text-gray-700">
          URL a ser analisada
        </label>
        <Input
          id="url"
          type="url"
          placeholder="Ex: https://www.exemplo.com.br/pagina"
          value={url}
          onChange={(e) => onUrlChange(e.target.value)}
          className="w-full"
          required
        />
      </div>
    </>
  );
}